const TabBar = ({ activeTab, onTabChange }) => {
  const tabs = ["Context", "AI Analysis", "Actions", "Templates"];

  return (
    <div className="tab-bar">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`tab-btn ${activeTab === tab ? "tab-btn--active" : ""}`}
          onClick={() => onTabChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default TabBar;
